if (!customElements.get("m-featured-collection")) {
    class e extends HTMLElement {
        constructor() {
            super();
        }
        connectedCallback() {
            (this.selectors = {
                loadMoreBtn: "[data-load-more]",
                loadMoreBtnWrapper: ".m-featured-collection__button",
                productsContainer: "[data-products-container]",
                products: [".m-product-card"],
                soldNumber: ["[data-sold-number]"],
                availableNumber: ["[data-available-number]"],
                countDown: "[data-flashsale-countdown]",
                slideControls: ".m-slider-controls",
                slideContainer: ".m-mixed-layout__wrapper",
            }),
                (this.domNodes = queryDomNodes(this.selectors, this)),
                (this.buttonType = this.dataset.buttonType),
                (this.infiniteLoad = this.dataset.infiniteLoad),
                (this.enableSlider = "true" === this.dataset.enableSlider),
                (this.showPagination = "true" === this.dataset.showPagination),
                (this.showNavigation = "true" === this.dataset.showNavigation),
                (this.enableFlashsale = "true" === this.dataset.enableFlashsale),
                (this.enableCountdown = "true" === this.dataset.enableCountdown),
                (this.id = this.dataset.id),
                (this.items = this.dataset.items),
                (this.mobileDisableSlider = "true" === this.dataset.mobileDisableSlider),
                this.initByScreenSize(),
                document.addEventListener("matchMobile", () => {
                    this.initByScreenSize();
                }),
                document.addEventListener("unmatchMobile", () => {
                    this.initByScreenSize();
                }),
                this.enableFlashsale && this.initFlashSale(),
                (this.canLoad = !0),
                (this.currentPage = 1),
                (this.spinner = spinner()),
                this.enableSlider || "load" !== this.buttonType || "true" !== this.infiniteLoad || this.initInfiniteLoad(),
                this.enableSlider || "load" !== this.buttonType || this.initLoadMore(),
                MinimogTheme.config.mqlMobile && this.mobileDisableSlider && "load" === this.buttonType && "true" === this.infiniteLoad && this.initInfiniteLoad(),
                MinimogTheme.config.mqlMobile && this.mobileDisableSlider && "load" === this.buttonType && this.initLoadMore(),
                document.addEventListener("matchMobile", () => {
                    MinimogTheme.config.mqlMobile && this.mobileDisableSlider && "load" === this.buttonType && this.initLoadMore(),
                        MinimogTheme.config.mqlMobile && this.mobileDisableSlider && "load" === this.buttonType && "true" === this.infiniteLoad && this.initInfiniteLoad();
                });
        }
        initByScreenSize() {
            if (!this.enableSlider) return;
            const { slideContainer: e, slideControls: t } = queryDomNodes(this.selectors, this);
            MinimogTheme.config.mqlMobile && this.mobileDisableSlider
                ? (t && t.classList.add("m:hidden"), e && e.classList.remove("swiper-container"), this.swiper && this.swiper.destroy(!1, !0))
                : (t && t.classList.remove("m:hidden"), this.initSlider());
        }
        initSlider() {
            const { slideContainer: e } = queryDomNodes(this.selectors, this),
                t = this.querySelector(".m-slider-controls"),
                i = t && t.querySelector(".m-slider-controls__button-prev"),
                s = t && t.querySelector(".m-slider-controls__button-next"),
                o = e.querySelector(".swiper-wrapper").childElementCount;
            e && e.classList.add("swiper-container"),
                (this.slider = new MinimogLibs.Swiper(e, {
                    slidesPerView: 2.5,
                    showPagination: this.showPagination,
                    showNavigation: this.showNavigation,
                    loop: !this.enableFlashsale,
                    pagination: !!this.showPagination && { el: this.querySelector(".swiper-pagination"), clickable: !0 },
                    breakpoints: { 768: { slidesPerView: parseFloat(this.items) >= 3 ? 3.5 : parseFloat(this.items) }, 1024: { slidesPerView: parseFloat(this.items) >= 4 ? 4.5 : parseFloat(this.items) }, 1280: { slidesPerView: parseFloat(this.items) } },
                    threshold: 2,
                    on: {
                        init: () => {
                            setTimeout(() => {
                                const e = this.querySelector(".m-image") || this.querySelector(".m-placeholder-svg");
                                if (e && t) {
                                    const o = e.clientHeight;
                                    t.style.setProperty("--offset-top", parseInt(o) / 2 + "px"), i && i.classList.remove("m:hidden"), s && s.classList.remove("m:hidden");
                                }
                            }, 200);
                        },
                        breakpoint: (e, i) => {
                            if (t) {
                                const { slidesPerView: s } = i;
                                o > s ? (t.classList.remove("m:hidden"), (e.allowTouchMove = !0)) : (t.classList.add("m:hidden"), (e.allowTouchMove = !1));
                            }
                        },
                    },
                })),
                this.slider && this.showNavigation && (i && i.addEventListener("click", () => this.slider.slidePrev()), s && s.addEventListener("click", () => this.slider.slideNext())),
                (this.swiper = e && e.swiper);
        }
        initLoadMore() {
            (this.triggerLoad = !1),
                (this.totalPages = parseInt(this.dataset.totalPages)),
                addEventDelegate({
                    context: this.container,
                    selector: this.selectors.loadMoreBtn,
                    handler: (e) => {
                        e.preventDefault(), this.handleLoadMore();
                    },
                });
        }
        initInfiniteLoad() {
            const e = this.dataset.maxPages;
            window.addEventListener("scroll", (t) => {
                (this.canLoad = this.currentPage < parseInt(e)), this.canLoad && this.offsetTop + this.clientHeight - window.innerHeight < window.scrollY && !this.triggerLoad && ((this.triggerLoad = !0), this.handleLoadMore());
            });
        }
        async handleLoadMore() {
            this.currentPage++, (this.canLoad = this.currentPage < this.totalPages), this.toggleLoading(!0);
            const e = this.dataset.collectionId,
                t = await fetchCountDown(e),
                i = `${this.dataset.url}?page=${this.currentPage}&section_id=${this.id}`;
            fetchCache(i).then((e) => {
                this.toggleLoading(!1);
                const i = generateDomFromString(e).querySelector(this.selectors.productsContainer),
                    s = this.domNodes.productsContainer.childElementCount;
                let o = !1;
                if (
                    (i &&
                        Array.from(i.childNodes).forEach((e) => {
                            this.domNodes.productsContainer.appendChild(e);
                            const t = setInterval(() => {
                                this.domNodes.productsContainer.childElementCount > s && (clearInterval(t), (o = !0));
                            }, 50);
                        }),
                    this.enableFlashsale && t.ok && t.payload && t.payload.length)
                ) {
                    const { expires_date: e } = t.payload[0];
                    this.expires_date = e;
                    const i = setInterval(() => {
                        if (o) {
                            clearInterval(i);
                            this.domNodes.productsContainer.querySelectorAll(".m-product-card").forEach((e) => {
                                const i = e.querySelector(".m-product-card__content");
                                if (!e.querySelector(".m-product-sale-progress")) {
                                    let s;
                                    e.dataset.soldNumber && (s = e.dataset.soldNumber);
                                    const o = saleProgress(t.payload[0], e.dataset.productId, s),
                                        a = generateDomFromString(o);
                                    i.appendChild(a);
                                }
                            });
                        }
                    }, 50);
                }
                (this.triggerLoad = !1), this.canLoad || (this.domNodes.loadMoreBtn && this.domNodes.loadMoreBtn.classList.add("m:hidden"));
            });
        }
        toggleLoading(e) {
            this.domNodes.loadMoreBtn && (e ? this.domNodes.loadMoreBtn.classList.add("m-spinner-loading") : this.domNodes.loadMoreBtn.classList.remove("m-spinner-loading"));
        }
        async initFlashSale() {
            const e = this.dataset.collectionId,
                t = await fetchCountDown(e);
            if (t.ok && t.payload && t.payload.length) {
                const { expires_date: e } = t.payload[0];
                (this.expires_date = e),
                    this.domNodes.products.forEach((e) => {
                        const i = e.querySelector(".m-product-card__content"),
                            s = e.querySelector(".m-product-sale-progress");
                        let o;
                        e.dataset.soldNumber && (o = e.dataset.soldNumber);
                        const a = saleProgress(t.payload[0], e.dataset.productId, o),
                            n = generateDomFromString(a);
                        s || i.appendChild(n);
                    }),
                    this.initCountDown();
            }
        }
        initCountDown() {
            const e = new Date(this.expires_date).getTime();
            this.countDownTimer = new CountdownTimer(this.domNodes.countDown, Date.now(), e, { loop: !0 });
        }
    }
    customElements.define("m-featured-collection", e);
}

// Load more pagination
document.addEventListener("DOMContentLoaded", function() {
    const loadMoreButton = document.querySelector('#pagination .load-more');
    const loadBtnWrapper = document.querySelector('#pagination');
    let isLoading = false;

    // Function to load the next page content
    function loadNextPage(page) {
        let nextPage = loadMoreButton ? loadMoreButton.getAttribute('data-next-page') : null;
        if (isLoading) {
            return;
        }  

        isLoading = true;

        fetch(nextPage)
        .then(response => response.text())
        .then(data => {
            const newContent = new DOMParser().parseFromString(data, 'text/html').querySelectorAll('.lightbox-wrapper');
            const pagination = new DOMParser().parseFromString(data, 'text/html').querySelector('#pagination');

            // Append the new content
            loadBtnWrapper.style.display = 'none';
            newContent.forEach(gallery => {
                document.querySelector('.material-insights-lightbox-inner').appendChild(gallery.cloneNode(true));
            });
            initPhotoSwipe()

            // If there is more pagination, update the button's next page value
            if (pagination) {
                const newNextPage = pagination.getAttribute('data-next-page');
                if (newNextPage) {
                    loadBtnWrapper.style.display = 'block';
                    isLoading = false;
                    loadMoreButton.setAttribute('data-next-page', newNextPage);
                } else {
                    loadBtnWrapper.style.display = 'none'; // Hide button if no more pages
                }
            }
        })
        .catch(error => console.error('Error loading next page:', error));
    }

    // Trigger loadNextPage when user scrolls to the bottom
    window.addEventListener('scroll', function() {
      if (loadBtnWrapper) {
        const rect = loadBtnWrapper.getBoundingClientRect();

        // Check if the top of the pagination wrapper is above the bottom of the viewport
        if (rect.top < window.innerHeight - 50) {
          loadNextPage(loadBtnWrapper.getAttribute('data-next-page'));
        }
      }
    });
});

// Photoswipe
function initPhotoSwipe() {
    const photo_swipe_options = {
        gallery: '.m-mixed-layout__wrapper', // Targeting swiper containers
        pswpModule: MinimogLibs.PhotoSwipeLightbox.PhotoSwipe,
        children: 'div.swiper-slide a', // Make sure each image is wrapped in an anchor tag (<a>)
        initialZoomLevel: 'fill',
        imageClickAction: 'next',
        tapAction: 'next',
        zoom: false,
        close: true,
        arrowKeys: true,
        counter: false
    };

    const lightbox = new MinimogLibs.PhotoSwipeLightbox(photo_swipe_options);
    lightbox.init();
}

document.addEventListener('DOMContentLoaded', function () {
    initPhotoSwipe();

    // Update image width and height for mobile
    const mediaQuery = window.matchMedia("(max-width: 768px)");

    function updateImageData(link) {
      const imageRatio = parseFloat(link.getAttribute('data-image-ratio'));
      const isMobile = mediaQuery.matches;

      function setSize(width, height) {
        link.setAttribute('data-pswp-width', width);
        link.setAttribute('data-pswp-height', height);
      }

      function handleImageRatio(ratio) {
        if (ratio == 1.3 || ratio == 1.33 || ratio == 1.34) {
          return isMobile ? setSize(500, 384.62) : setSize(1200, 900);
        } else if (ratio == 0.8 || ratio == 0.75) {
          return isMobile ? setSize(480, 600) : setSize(675, 900);
        }
      }

      if (imageRatio) {
        handleImageRatio(imageRatio);
      } else {
        const images = link.querySelector('.search-images');

        if (images.complete) {
          let ratio = (images.naturalWidth / images.naturalHeight);
          ratio = Math.round(ratio * 100) / 100;
          handleImageRatio(ratio);
        } else {
          images.onload = () => {
            let ratio = (images.naturalWidth / images.naturalHeight);
            ratio = Math.round(ratio * 100) / 100;
            handleImageRatio(ratio);
          };
        }
      }
    }

    function updateGallery() {
      const allLinks = document.querySelectorAll('.swiper-slide > a');

      if (allLinks) {
        allLinks.forEach(updateImageData);
      }
    }

    // run on page load
    updateGallery();

    // run on resuze
    mediaQuery.addEventListener("change", (e) => {
      updateGallery();
    });

    const galleryContainer = document.querySelector('.material-insights-lightbox-inner');
    let newNodesAdded = 0;
    const nodesToAdd = 5;

    const observer = new MutationObserver((mutations) => {
      mutations.forEach(mutation => {
        if (mutation.addedNodes.length > 0) {
          newNodesAdded += 1;

          if (newNodesAdded >= nodesToAdd) {
            updateGallery();
            newNodesAdded = 0;
          }
        }
      });
    });

    if (galleryContainer) {
      observer.observe(galleryContainer, {
        childList: true
      });
    }
})

// Load search results
const urlParams = new URLSearchParams(window.location.search);
const titleSearch = urlParams.get("q");

if (titleSearch) {
  const RESULTS_PER_PAGE = 5;
  let allResults = [];
  let currentPage = 1;
  let isLoading = false;

  const fetchAllEntries = async () => {
    const SHOPIFY_DOMAIN = "oakel-city-floor.myshopify.com";  // Replace with your Shopify store domain
    const STOREFRONT_ACCESS_TOKEN = "747e056af17a165bd0f354061de46311";  // Replace with your Storefront Access Token
    const endpoint = `https://${SHOPIFY_DOMAIN}/api/2025-04/graphql.json`;

    // GraphQL query to fetch all entries (metaobjects)
    const query = `
    query GetAllMaterialInsights($cursor: String) {
        metaobjects(first: 250, type: "material_insights", after: $cursor) {
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
            node {
            id
            handle
            title: field(key: "title") {
                value
            }
            images: field(key: "images") {
                value
                type
            }
            images_2: field(key: "images_2") {
                value
                type
            }
            }
        }
        }
    }
    `;

    // Helper function to resolve a MediaImage GID to an image URL
    async function resolveMediaImages(gids) {
      if (!gids.length) return [];
    
      const nodesQuery = `
        query getMediaItems($ids: [ID!]!) {
          nodes(ids: $ids) {
            ... on MediaImage {
              id
              image {
                url
                altText
              }
            }
            ... on Video {
              id
              sources {
                url
                mimeType
              }
            }
          }
        }
      `;
    
      const response = await fetch(endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": STOREFRONT_ACCESS_TOKEN,
        },
        body: JSON.stringify({ query: nodesQuery, variables: { ids: gids } }),
      });
    
      const data = await response.json();
      const nodes = data?.data?.nodes || [];

      // Filter and normalize output
      const media = nodes.map((node) => {
        if (node?.image?.url) {
          return {
            type: "image",
            url: node.image.url,
            alt: node.image.altText,
          };
        } else if (node?.sources?.length) {
          return {
            type: "video",
            url: node.sources[0].url,
            mimeType: node.sources[0].mimeType,
          };
        }
        return null;
      }).filter(Boolean);
    
      return media;
    }

    // Main fetch function
    async function getMaterialInsights(titleSearch = null) {
      let allEdges = [];
      let hasNextPage = true;
      let cursor = null;
    
      while (hasNextPage) {
        const response = await fetch(endpoint, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Shopify-Storefront-Access-Token": STOREFRONT_ACCESS_TOKEN,
          },
          body: JSON.stringify({ query, variables: { cursor } }),
        });
    
        const result = await response.json();
        const metaobjects = result?.data?.metaobjects;
    
        if (!metaobjects?.edges?.length) break;
    
        allEdges = [...allEdges, ...metaobjects.edges];
    
        hasNextPage = metaobjects.pageInfo.hasNextPage;
        cursor = metaobjects.pageInfo.endCursor;
      }
    
      // Sort and filter
      allEdges.sort((a, b) => a.node.handle.localeCompare(b.node.handle));
    
      // Normalize string for comparison: replace periods, dashes, underscores with spaces
      const normalizeForSearch = (str) => str.toLowerCase().replace(/[.\-_]/g, " ");

      const matchingEntries = allEdges.filter((edge) => {
        const title = edge.node.title?.value || "";
        return !titleSearch || normalizeForSearch(title).includes(normalizeForSearch(titleSearch));
      });
    
      return matchingEntries.map((edge) => {
        const node = edge.node;
        return {
          id: node.id,
          handle: node.handle,
          title: node.title?.value || "",
          media: node.images?.value || "{}",
          media_2: node.images_2?.value || "{}"
        };
      });
    }

    // Function to display results
    function displayResults(results) {
      const resultsContainer = document.querySelector('.material-insights-lightbox-inner');
      const galleryWrapper = document.querySelector('.lightbox-wrapper');

      results.forEach((entry) => {
        // Add heading
        const galleryClone = galleryWrapper.cloneNode(true);
        galleryClone.style.display = "block"

        const titleElement = galleryClone.querySelector('.m-section__heading');
        if (titleElement) {
          titleElement.innerText = entry.title;  // Insert the title into the cloned element
        }

        //Add Images
        entry.media.forEach((imageURL) => {
        const column = document.createElement('div');
        column.classList.add('swiper-slide');
        column.classList.add('m:column');


        if (imageURL.type === "image") {
          const anchor = document.createElement('a');
          anchor.href = imageURL.url;
          anchor.setAttribute('data-pswp-width', '1200');
          anchor.setAttribute('data-pswp-height', '900');
          anchor.setAttribute('data-cropped', 'true');

          const image = document.createElement('img');
          image.classList.add('search-images')
          image.src = `${imageURL.url}&width=360`;
          image.srcset = `
            ${imageURL.url}&width=165 165w,
            ${imageURL.url}&width=360 360w,
            ${imageURL.url}&width=533 533w,
            ${imageURL.url}&width=720 720w,
            ${imageURL.url}&width=940 940w,
            ${imageURL.url}&width=960 960w
          `;

          const zoomIcon = `
          <div class="zoom-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
              <g clip-path="url(#clip0_3010_8701)">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M2.80078 4.76416C2.80037 4.59848 2.93434 4.46383 3.10003 4.46341L6.4202 4.45508C6.58592 4.45467 6.72056 4.58864 6.72098 4.75433C6.7214 4.92001 6.58742 5.05466 6.4217 5.05508L3.10153 5.06341C2.93585 5.06383 2.8012 4.92985 2.80078 4.76416Z" fill="black"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M4.7553 2.79883C4.92098 2.79842 5.05564 2.93239 5.05606 3.09807L5.06438 6.41825C5.0648 6.58397 4.93082 6.71861 4.76513 6.71903C4.59945 6.71945 4.4648 6.58547 4.46438 6.41975L4.45606 3.09958C4.45564 2.9339 4.58962 2.79924 4.7553 2.79883Z" fill="black"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M7.69944 1.81807C6.0753 0.193977 3.44216 0.193977 1.81807 1.81807C0.193977 3.44216 0.193977 6.07536 1.81807 7.69944C3.44216 9.32352 6.0753 9.32352 7.69944 7.69944C9.32352 6.07536 9.32352 3.44216 7.69944 1.81807ZM1.39381 1.39381C3.25221 -0.464602 6.26526 -0.464602 8.1237 1.39381C9.96606 3.23617 9.98196 6.21336 8.1714 8.07528L10.9484 10.8523C11.0656 10.9694 11.0656 11.1594 10.9484 11.2766C10.8313 11.3937 10.6413 11.3937 10.5241 11.2766L7.72668 8.47908C5.8583 9.97338 3.12503 9.85494 1.39381 8.1237C-0.464602 6.26526 -0.464602 3.25221 1.39381 1.39381Z" fill="black"/>
              </g>
              <defs>
              <clipPath id="clip0_3010_8701">
              <rect width="12" height="12" fill="white"/>
              </clipPath>
              </defs>
              </svg>
          </div>
          `;

          anchor.insertAdjacentHTML('beforeend', zoomIcon);
          anchor.appendChild(image);
          column.appendChild(anchor);
        } else if (imageURL.type === "video") {
          const videoWrapper = document.createElement('div');
          videoWrapper.classList.add('video-wrapper');

          const mediaElement = document.createElement('video');
          mediaElement.setAttribute("playsinline", "playsinline");
          mediaElement.setAttribute("controls", "controls");

          const sourceTag = document.createElement('source');
          sourceTag.src = imageURL.url;
          sourceTag.setAttribute("type", "video/mp4");

          mediaElement.appendChild(sourceTag)
          videoWrapper.appendChild(mediaElement);
          column.appendChild(videoWrapper);
        }
        
        galleryClone.querySelector('.m-mixed-layout__inner').appendChild(column);
        })

        resultsContainer.appendChild(galleryClone);

      });
      initPhotoSwipe();
    }

    // Pagination functionality
    async function loadNextPage() {
      if (isLoading) return;
      isLoading = true;

      const startIndex = (currentPage - 1) * RESULTS_PER_PAGE;
      const endIndex = currentPage * RESULTS_PER_PAGE;
      const nextResults = allResults.slice(startIndex, endIndex);
      const remaining = allResults.slice(endIndex, allResults.length);

      if (nextResults.length > 0) {
        const resolvedResults = await Promise.all(nextResults.map(async (entry) => {
          let allImageGIDs = [];
          try {
            const raw = entry.media || "[]";
            const imageGIDs = Array.isArray(raw) ? raw : JSON.parse(raw) || [];
            
            allImageGIDs = [...imageGIDs];

            // Only add images_2 if it exists and is not empty
            if (entry.media_2 && entry.media_2 !== "[]") {
              const raw2 = entry.media_2;
              const imageGIDs2 = Array.isArray(raw2) ? raw2 : JSON.parse(raw2) || [];
              if (Array.isArray(imageGIDs2) && imageGIDs2.length > 0) {
                allImageGIDs = [...allImageGIDs, ...imageGIDs2];
              }
            }
            
          } catch (err) {
            console.warn(`Failed to parse image GIDs for '${entry.handle}'`, err);
          }
      
          const mediaItems = await resolveMediaImages(allImageGIDs);
      
          return {
            id: entry.id,
            handle: entry.handle,
            title: entry.title,
            media: mediaItems.filter(Boolean),
          };
        }));

        displayResults(resolvedResults);
        currentPage++;
      }
      
      if (remaining.length > 0) {
        document.getElementById('search-pagination').style.display = "block";
      } else {
        document.getElementById('search-pagination').style.display = "none";
      }

      isLoading = false;
    }

    window.addEventListener('scroll', function() {
      const paginationBtn = this.document.getElementById('search-pagination');

      if (paginationBtn) {
        const rect = paginationBtn.getBoundingClientRect();

        // Check if the top of the pagination wrapper is above the bottom of the viewport
        if (rect.top < window.innerHeight - 50) {
          loadNextPage();
        }
      }
    });

    // Call the function and log the result
    try {
    allResults = await getMaterialInsights(titleSearch);

    if (allResults.length > 0) {
      loadNextPage();
      const swiperSkeleton = document.querySelector('.material-insights-lightbox-inner .lightbox-wrapper:first-child');
      swiperSkeleton.style.display = "none";
    } else {
      const noResults = document.querySelector('.material-insights-lightbox-section .no-results');
      noResults.style.display = "block";
      const paginationWrapper = document.getElementById('search-pagination');
      paginationWrapper.style.display = "none";
    }
    } catch (error) {
      console.error("Error fetching material insights:", error);
    }
  };

  // Run the function to fetch and log the recipes
  fetchAllEntries();
}